import { CraSimulateResults } from "@keita/lanepatrol-sdk";
import { CraSimulatedResult } from "../../project/models/CraForecastScenario";
import {
  jwtAuthAxios,
  optionalAuthAxios,
} from "../../shared/utils/network-utils";
import {
  OsaNodeCoding,
  CreateOrUpdateOsaNodeCoding,
} from "../models/OsaNodeCoding";

export const OsaNodeCodingApi = {
  batchUpdate: async (codingEntries: CreateOrUpdateOsaNodeCoding[]) => {
    return await jwtAuthAxios().put<OsaNodeCoding[]>(
      `/osa-node-coding`,
      codingEntries
    );
  },

  simulateResults: async (body: CraSimulateResults) => {
    return await optionalAuthAxios().post<CraSimulatedResult[]>(
      `/osa-node-coding/simulate-results`,
      body
    );
  },
};
